import { render, staticRenderFns } from "./CardEcologist.vue?vue&type=template&id=6f189e90&scoped=true&"
import script from "./CardEcologist.vue?vue&type=script&lang=js&"
export * from "./CardEcologist.vue?vue&type=script&lang=js&"
import style0 from "./CardEcologist.vue?vue&type=style&index=0&id=6f189e90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f189e90",
  null
  
)

export default component.exports